import React from "react";
import { Link } from "react-router-dom";
import { businessItems, company } from "../data/siteData";
import SectionTitle from "./SectionTitle";
import Reveal from "./Reveal";

function BusinessVisual({ index }) {
  if (index === 0)
    return (
      <figure className="business-photo">
        <img
          src="/m-banner44.jpg"
          alt="複数の酒類・箱入り商品が並ぶ陳列棚"
          loading="lazy"
          width="750"
          height="1100"
        />
        <figcaption>PRODUCT SELECTION / 取扱商品の一例</figcaption>
      </figure>
    );
  if (index === 1)
    return (
      <div className="channel-panel">
        <p className="eyebrow">OUR ONLINE CHANNELS</p>
        <h4>
          商品と需要を、
          <br />
          オンラインでつなぐ。
        </h4>
        {company.marketplace.map((shop) => (
          <a key={shop.label} href={shop.href} target="_blank" rel="noreferrer">
            <span>{shop.label}</span>
            <small>公式ショップを見る</small>
            <b aria-hidden="true">↗</b>
          </a>
        ))}
        <p className="channel-caption">
          商品選定 → オンライン販売 → 受注・出荷
        </p>
      </div>
    );
  return (
    <div className="flow-panel">
      <p className="eyebrow">FROM ORDER TO DELIVERY</p>
      <ol>
        {[
          ["01", "ORDER", "ご相談・受注"],
          ["02", "STOCK", "在庫・納期の確認"],
          ["03", "DISPATCH", "手配・出荷"],
          ["04", "DELIVERY", "全国へお届け"],
        ].map(([n, en, ja]) => (
          <li key={n}>
            <span>{n}</span>
            <strong>{en}</strong>
            <small>{ja}</small>
          </li>
        ))}
      </ol>
      <p>
        法人配送から通販出荷まで。
        <br />
        商品を必要な場所へつなぎます。
      </p>
    </div>
  );
}

export default function BusinessSection() {
  return (
    <section id="business" className="business section">
      <div className="container">
        <SectionTitle
          label="02 — OUR BUSINESS"
          title={
            <>
              三つの事業で、
              <br />
              酒類の流れをつくる。
            </>
          }
          description="商品を仕入れ、販売し、届ける。互いにつながる事業が、取引先の可能性を広げます。"
          dark
        />
        <div className="business__list">
          {businessItems.map((item, index) => (
            <Reveal as="article" className="business-item" key={item.number}>
              <div className="business-item__content">
                <p className="business-index">
                  {item.number}
                  <span>{item.japanese}</span>
                </p>
                <h3>{item.english}</h3>
                <h4>{item.lead}</h4>
                <p>{item.description}</p>
                <Link className="text-link text-link--light" to="/contact">
                  {item.japanese}のご相談 <span>↗</span>
                </Link>
              </div>
              <BusinessVisual index={index} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
